const sorts = {
  namespaced: true,
  state: {
    status: "",
    conf: {},
  },

  mutations: {
    SORT_SAVE(state, { name, criteria }) {
      state.conf[name] = criteria;
      state.status = "saved";
    },
    SORT_REMOVE(state, name) {
      delete state.conf[name];
      state.status = "removed";
    },
    SORT_REMOVE_ALL(state) {
      state.conf = {};
      state.status = "removed all";
    },
    SORT_ERROR(state) {
      state.status = "error";
    },
  },

  actions: {
    saveByName({ commit }, obj) {
      // console.debug("sorts action saveByName", obj);
      commit("SORT_SAVE", obj);
    },
    removeByName({ commit }, name) {
      // console.debug("sorts action removeByName", name);
      commit("SORT_REMOVE", name);
    },
    removeAll({ commit }) {
      // console.debug("sorts action removeAll");
      commit("SORT_REMOVE_ALL");
    },
  },

  getters: {
    loadByName: (state) => (name) => {
      //name is a parameter for the getter
      // console.debug("sorts getter loadByName", name);
      return state.conf[name];
    },
  },
};
export default sorts;
